import { Textarea } from "@/components/ui/textarea";

function CategoryRow({ cat, criterion, readOnly, onCriterion }) {
  const desc = criterion?.description || "";
  return (
    <li data-testid={`category-row-${cat.id}`} className="px-5 py-4">
      <p className="font-heading font-semibold">{cat.name}</p>
      {readOnly ? (
        <p className="mt-1 text-sm text-plena-text2" data-testid={`category-description-value-${cat.id}`}>{desc}</p>
      ) : (
        <Textarea data-testid={`category-description-${cat.id}`} value={desc} onChange={(e) => onCriterion({ description: e.target.value })} rows={2} className="mt-2 max-w-2xl rounded-xl text-sm" placeholder="Bu kategoride değerlendirici neye bakmalı?" />
      )}
    </li>
  );
}

export function CriteriaBuilder({ rubric, onChange, readOnly = false }) {
  const categories = [...rubric.categories].sort((a, b) => a.display_order - b.display_order);
  const critOf = (cid) => rubric.criteria.find((c) => c.category_id === cid);
  const updateCriterion = (catId, patch) => onChange({ ...rubric, criteria: rubric.criteria.map((c) => (c.category_id === catId ? { ...c, ...patch } : c)) });
  return (
    <div className="space-y-5" data-testid="criteria-builder">
      <p className="text-sm text-plena-text2" data-testid="active-category-count">{categories.length} sabit kategori · Ağırlık yok: kategori önceliğini değerlendiriciler belirler.</p>
      <ul className="plena-card divide-y divide-plena-border">
        {categories.map((cat) => <CategoryRow key={cat.id} cat={cat} criterion={critOf(cat.id)} readOnly={readOnly} onCriterion={(p) => updateCriterion(cat.id, p)} />)}
      </ul>
    </div>
  );
}
